import useTableWithRequest from '../../shared/Table/ctrl/useTableWithRequest'
import promosApi from './promos.api'
import { useState } from 'react'
import { IPromo } from './promos.types'
import Table from '../../shared/Table'
import promoFields from './promo.fields'
import Button from '../../shared/Buttons/Button'
import CreatePromoModal from './components/CreatePromoModal'
import css from './promo.module.css'
import logoSrc from '../../asserts/logo.png'
import GrantUserSubscriptionModal from './components/GrantUserSubscriptionModal'

const PromosScreen = () => {
  const [createPromoModal, setCreatePromoModal] = useState(false)
  const [createSubscription, setCreateSubscriptionModal] = useState(false)
  const [items, setItems] = useState<IPromo[]>([])

  const tableCtrl = useTableWithRequest<IPromo>({
    storageType: 'inMemory',
    dataFetcher: promosApi.getPromosList,
    fields: promoFields,
    items,
    setItems,
    itemKey: 'id',
    tableKey: 'plan',
  })

  return (
    <div className={css.wrapper}>
      <img src={logoSrc} alt="Небумага" className={css.logo} />
      <div className={css.heading}>
        <h2 className="form-header" style={{ textAlign: 'center' }}>
          Промокоды
        </h2>
        <div className="inline-flex-gap">
          <Button onClick={() => setCreateSubscriptionModal(true)}>Выдать подписку</Button>
          <Button onClick={() => setCreatePromoModal(true)}>Добавить промо</Button>
        </div>
      </div>

      <div className={css.card}>
        <div className={css.table}>
          <Table
            fields={tableCtrl.fields}
            loading={tableCtrl.loading}
            items={tableCtrl.orderedItems}
            itemKey="id"
            totalItemsCount={tableCtrl.totalItemsCount}
            pageNumber={tableCtrl.pageNumber}
            itemsPerPage={tableCtrl.itemsPerPage}
            orderingState={tableCtrl.orderingState}
            onOrderingStateChange={tableCtrl.onOrderingStateChange}
            onSwap={tableCtrl.onSwap}
            resizePluginCtrl={tableCtrl.resizePluginCtrl}
          />
        </div>
      </div>
      {createPromoModal && (
        <CreatePromoModal
          onClose={() => setCreatePromoModal(false)}
          onSuccess={(created) => {
            setCreatePromoModal(false)
            setItems((prev) => [created, ...prev])
          }}
        />
      )}
      {createSubscription && <GrantUserSubscriptionModal onClose={() => setCreateSubscriptionModal(false)} />}
    </div>
  )
}

export default PromosScreen
